import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {setAccessToken} from "../slices/authSlice";
import {TabsContext, TabsList, TabsTab, TabsPanel} from "@seismic/mantle";
import {useUserCommands} from "../hooks/userCommands";
import {IbmTab} from "../components/IbmTab";
import {MeetingOverviewTab} from "../components/MeetingOverviewTab";
import {GptTab} from "../components/GptTab";
import {MicrosoftTab} from "../components/MicrosoftTab";
import {MeetingTranscriptTab} from "../components/MeetingTranscriptTab";
import {MeetingSummaryTab} from "../components/MeetingSummaryTab";
import {MeetingSnowflakeSummaryTab} from "../components/MeetingSnowflakeSummaryTab";
import {MeetingSnowflakeRecommendationsTab} from "../components/MeetingSnowflakeRecommendationsTab";
import {Header} from "../components/Header";
import {resolveExternalMeeting} from "../api/client";
import {CenteredSpinner, CenteredSpinner2} from "../components/CenteredSpinner";

export const MeetingRedirect = () => {
    
    //get external meeting ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const externalMeetingId = urlParams.get('externalMeetingId');

    useEffect(() => {
        
        resolveExternalMeeting(externalMeetingId).then(a=>{
            window.location.href = "/Web?meetingId=" + a.id;
        })
        
    }, []);
    
    return <CenteredSpinner message={"Resolving meeting..."} />
}